module.exports = __webpack_public_path__ + "img/background-1.7d25fb31.jpg";